export default "__VITE_ASSET__D0nOgN_Q__"